(function () {
  function selectedAddons() {
    var items = [];
    document.querySelectorAll("[data-addon-include]:checked").forEach(function (box) {
      var row = box.closest("[data-addon-row]");
      var variantInput = row && row.querySelector("[data-addon-variant]");
      var id = variantInput && variantInput.value;
      if (id) items.push({ id: Number(id), quantity: 1 });
    });
    document.querySelectorAll("[data-matching-device]:checked").forEach(function (box) {
      var row = box.closest("[data-addon-row]") || box.closest(".matching-device__row");
      var sel = row && row.querySelector("[data-matching-device-select], [data-addon-variant]");
      items.push({ id: Number(sel && sel.value ? sel.value : box.value), quantity: 1 });
    });
    return items;
  }

  function mainItem(form) {
    var idInput = form.querySelector('[name="id"]');
    var qtyInput =
      form.querySelector('[name="quantity"]') ||
      document.querySelector('[name="quantity"][form="' + form.id + '"]');
    return {
      id: Number(idInput && idInput.value),
      quantity: Number((qtyInput && qtyInput.value) || 1),
    };
  }

  function cartEl() {
    return document.querySelector("cart-notification") || document.querySelector("cart-drawer");
  }

  function addItems(items, goToCheckout) {
    var cart = cartEl();
    var body = { items: items };
    if (cart && typeof cart.getSectionsToRender === "function" && !goToCheckout) {
      body.sections = cart.getSectionsToRender().map(function (section) {
        return section.id;
      });
      body.sections_url = window.location.pathname;
      cart.setActiveElement(document.activeElement);
    }
    return fetch(window.routes.cart_add_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/json",
      },
      body: JSON.stringify(body),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (response) {
        if (response.status) throw new Error(response.description || "cart add failed");
        if (goToCheckout) {
          window.location.href = "/checkout";
          return response;
        }
        if (cart && typeof cart.renderContents === "function") {
          cart.renderContents(response);
          return response;
        }
        window.location.href = window.routes.cart_url;
        return response;
      });
  }

  function isPaymentClick(event) {
    var path = event.composedPath ? event.composedPath() : [];
    for (var i = 0; i < path.length; i++) {
      var el = path[i];
      if (!el || !el.tagName) continue;
      var tag = el.tagName.toLowerCase();
      if (tag === "shopify-accelerated-checkout" || tag === "shopify-accelerated-checkout-cart") return true;
      if (el.classList && el.classList.contains("shopify-payment-button")) return true;
    }
    return false;
  }

  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target;
      if (!form || form.getAttribute("data-type") !== "add-to-cart-form") return;
      var extras = selectedAddons();
      if (!extras.length) return;
      var main = mainItem(form);
      if (!main.id) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      var button = form.querySelector('[type="submit"]');
      if (button) {
        button.setAttribute("aria-disabled", "true");
        button.classList.add("loading");
      }
      addItems([main].concat(extras), false).finally(function () {
        if (!button) return;
        button.classList.remove("loading");
        button.removeAttribute("aria-disabled");
      });
    },
    true
  );

  document.addEventListener(
    "click",
    function (event) {
      if (!isPaymentClick(event)) return;
      var extras = selectedAddons();
      if (!extras.length) return;
      var form = document.querySelector('form[data-type="add-to-cart-form"]');
      if (!form) return;
      var main = mainItem(form);
      if (!main.id) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      addItems([main].concat(extras), true);
    },
    true
  );
})();
